$('.product-styling-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    adaptiveHeight: true,
    centerMode: false,
    variableWidth: true,
    easing: 'swing'
});

const $variantStock = $("#variantStock");
const fewLeft = $variantStock.data("few-left");
const oneLeft = $variantStock.data("one-left");

function changeVariantQuantity(variantId) {
    let quantity = undefined;
    if(variantQuantities) {
        variantQuantities.forEach(function (variantQuantity){
            if(variantQuantity.id === variantId + "") {
                quantity = variantQuantity.quantity;
            }
        });
    }

    if (quantity && window.jQuery) {
        let quantityText = undefined;

        if(quantity >= 2 && quantity <= 4) {
            quantityText = fewLeft;
        } else if(quantity === 1) {
            quantityText = oneLeft;
        }

        const $variantStock = window.jQuery("#variantStock");

        if(quantityText) {
            $variantStock.text(quantityText);
            $variantStock.show();
        } else {
            $variantStock.text("");
            $variantStock.hide();
        }
    }
}
window.changeVariantQuantity = changeVariantQuantity;

// Cookieに同意された場合Clarityスクリプトを読み込む
window.Shopify.loadFeatures(
    [
        {
            name: 'consent-tracking-api',
            version: '0.1',
        },
    ],
    error => {
        if(error) {
            console.error('Error loading Shopify features: ', error);
            return;
        }

        if(window.Shopify.customerPrivacy.analyticsProcessingAllowed()) {
            (function(c,l,a,r,i,t,y){
                c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
                t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
                y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
            })(window, document, "clarity", "script", "u4urk0asue");
        }
    }
);